import {
  FaFileAlt, FaFileExcel, FaFileImage, FaFilePdf, FaFileWord,
} from "react-icons/fa";

// One card on the cylinder. An image card is the photo; anything else is an icon
// tile, so a claim's PDFs, reports and spreadsheets ride around with the photos
// instead of being silently dropped (Robert 2026-08-01, job 76403 — a claim whose
// documents are half the point of archiving it).
//
// The icon set is deliberately its own small map rather than a reach into the
// Files tab's: this folder stays self-contained, and a card seen at 200px while
// spinning wants far coarser categories than a file list does.

const BY_EXTENSION = [
  [/^(pdf)$/i, FaFilePdf, "#d0554d"],
  [/^(docx?|rtf|odt)$/i, FaFileWord, "#4a7ebb"],
  [/^(xlsx?|csv|ods)$/i, FaFileExcel, "#4f9d69"],
  [/^(jpe?g|png|gif|webp|heic|bmp|tiff?)$/i, FaFileImage, "#8a8478"],
];

function visualFor(ext) {
  const found = BY_EXTENSION.find(([re]) => re.test(ext || ""));
  return found ? { Icon: found[1], tint: found[2] } : { Icon: FaFileAlt, tint: "#8a8478" };
}

export default function FileCard({ item, innerRef }) {
  if (item?.src) {
    return (
      <div
        ref={innerRef}
        className="ph-card"
        style={{ backgroundImage: `url(${item.src})` }}
      />
    );
  }

  const ext = (item?.ext || "").replace(/^\./, "");
  const { Icon, tint } = visualFor(ext);
  return (
    <div ref={innerRef} className="ph-card ph-card-doc">
      <Icon className="ph-card-icon" style={{ color: tint }} />
      {ext ? <span className="ph-card-ext">{ext.toUpperCase()}</span> : null}
    </div>
  );
}
